<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Referral</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :page="currentPage"/>
          <link-button
            :click="() => openCreateModal()"
            :classes="['btn-info', 'd-block', 'ml-lg-3', 'm-l-15']"
          >
            <i class="fa fa-plus-circle" />
            Add referral
          </link-button>
        </div>
      </div>

    </div>
    <loading-container :loading="loading">
      <div v-if="!list || list.length == 0" class="text-center">
        No referral found
      </div>
      <div v-else class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-striped dataTable no-footer">
                  <thead>
                  <tr>
                    <th>#Id</th>
                    <th>Code</th>
                    <th>Date created</th>
                    <th>Date expired</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                  </thead>
                  <tbody>
                 <tr
                   v-for="(item, index) in list"
                   :class="index % 2 == 0 ? 'odd' : 'even'"
                   :key="item.code">
                   <td>
                     <span>{{item.userId}}</span>
                   </td>
                   <td>
                     <span>{{item.code}}</span>
                   </td>
                   <td>
                     <span>{{item.createdAt | dateDisplay}}</span>
                   </td>
                   <td>
                     <span>{{item.expiredDate | dateDisplay}}</span>
                   </td>
                   <td>
                     <span>{{item.status}}</span>
                   </td>
                   <td>
                     <div>
                       <button type="button" class="btn btn-secondary"
                        title="Delete store"
                        @click="() => openWarning(item.code)">
                         <i class="ti-trash"></i>
                       </button>
                     </div>
                   </td>
                 </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
     <div class="row">
       <div class="col-md-12 d-flex justify-content-center">
         <pagination
           :routeName="routeName"
           :current="page"
           :total="total"
         />
       </div>
     </div>
     <!-- Delete -->
     <modal
          :show="form.showDeleteConfirm"
          title="Warning"
          :close="() => setField({ key: 'showDeleteConfirm', value: false })"
        >
        <h2 class="swal2-title" style="display: flex;">Are you sure to delete?</h2>

          <div slot="footer">
            <div class="flex-group">
              <form-button
                :click="() => deleteReferral(form.deleteId)"
                type="primary"
                class="btn btn-danger mr-2"
                :loading="deleteLoading"
              >
                Sure
              </form-button>
              <button type="button"
                class="btn btn-secondary flex-item"
                @click="() => setField({ key: 'showDeleteConfirm', value: false })"
              >
                Cancel
              </button>
            </div>
          </div>
      </modal>
      <!-- Create -->
      <modal
        :show="form.showCreate"
        title="New Referral"
        :close="() => setField({ key: 'showCreate', value: false })"
      >
        <loading-container :loading="form.loadingModal">
          <form @submit.prevent="() => {}">
            <input-text
              :value="form.userId"
              label="User ID"
              :errors="error.userId"
              placeholder="userId"
              @input="value => { setField({ key: 'userId', value }) }"
            />
            <input-text
              :value="form.code"
              label="Referral Code"
              :errors="error.code"
              placeholder="code"
              @input="value => { setField({ key: 'code', value }) }"
            />
            <input-select
              label="Type"
              :value="form.type"
              placeholder="Choose One"
              :options="typeOptions"
              :errors="error.type"
              @input="value => { setField({ key: 'type', value }) }"
            />
            <input-text
              :value="form.sellerDiscount"
              label="Seller Discount"
              :errors="error.sellerDiscount"
              placeholder="Seller Discount"
              type="number"
              @input="value => { setField({ key: 'sellerDiscount', value }) }"
            />
            <input-text
              :value="form.referrerCompensation"
              label="Referrer Compensation"
              :errors="error.referrerCompensation"
              placeholder="Referrer Compensation"
              type="number"
              @input="value => { setField({ key: 'referrerCompensation', value }) }"
            />
            <input-text
              :value="form.maxUsesAllowed"
              label="Referral Limit"
              :errors="error.maxUsesAllowed"
              placeholder="Referral Limit"
              type="number"
              @input="value => { setField({ key: 'maxUsesAllowed', value }) }"
            />
            <div class="form-group" :class="{'has-danger': error.expiredDate}">
              <label>Expired date</label>
              <datetime
                v-model="expiredDate"
                input-id="expiredDate"
                format="yyyy-MM-dd HH:mm"
                type="datetime"
                :zone="timezone"
                :auto="true"
                input-class="form-control"
              >
              </datetime>
              <small v-if="error.expiredDate" class="form-control-feedback">can't be blank</small>
            </div>
          </form>
        </loading-container>
        <div slot="footer" v-if="!form.loadingModal">
          <form-button
            type="primary"
            :loading="form.creating"
            :click="createReferral"
            text="SAVE"
          />
        </div>
      </modal>
    </loading-container>
  </div>
</template>


<script>
  import { mapGetters, mapActions } from "vuex";
  import moment from 'moment';

  import LoadingContainer from "@/components/Misc/LoadingContainer";
  import InputSelect from "@/components/Form/InputSelect";
  import InputText from "@/components/Form/InputText";
  import Pagination from "@/components/Misc/Pagination";
  import LinkButton from "@/components/Misc/LinkButton";
  import FormButton from "@/components/Form/FormButton";
  import Breadcrumb from "@/components/Common/Breadcrumb";
  import Modal from "@/components/Misc/Modal";
  import { Datetime } from 'vue-datetime';

  export default {
    name: "ListReferral",
    components: {
      LoadingContainer,
      InputSelect,
      Pagination,
      LinkButton,
      InputText,
      FormButton,
      Breadcrumb,
      Modal,
      Datetime
    },
    beforeMount() {
      const query = this.$route.query;
      const page = query.page ? parseInt(query.page) : 1;
      this.getListReferral({ page });
    },
    computed: {
      ...mapGetters({
        loading: "referral/loading",
        list: "referral/list",
        userList: "user/list",
        count: "referral/count",
        page: "referral/page",
        total: "referral/total",
        form: "referral/form",
        error: 'referral/error',
        deleteLoading: "referral/deleteLoading",
      }),
      routeName() {
        return this.$router.name;
      },
      currentPage() {
        return this.$store.state.route.meta.title;
      },
      userOptions() {
        const users = this.userList
          .map(o => {
            return {
              value: o.id,
              text: `${o.id} - ${o.email}`
            };
          });

        return users;
      },
      typeOptions() {
        return [
          { value: 'per_order', text: 'Per Order'},
          { value: 'per_item', text: 'Per Item'},
        ]
      },
      expiredDate: {
        get() {
          return this.form.expiredDate ? this.form.expiredDate: '';
        },
        set(value) {
          if (value) {
            this.setField({key: 'expiredDate', value: value})
          }
        }
      },
      timezone() {
        return process.env.VUE_APP_TIMEZONE
      },
    },
    methods: {
      ...mapActions({
        setField: "referral/setField",
        getListReferral: "referral/getListReferral",
        deleteReferral: "referral/deleteReferral",
        createReferral: "referral/createReferral",
        openCreateModal: "referral/openCreateModal",
      }),
      openWarning(deleteId) {
        this.setField({ key: 'showDeleteConfirm', value: true });
        this.setField({ key: 'deleteId', value: deleteId });
      },
    }
  };
</script>
